// This import loads the firebase namespace along with all its type information.
import GameContext from './game-context-model'

export async function load_gameContexts(): Promise<GameContext[]> {
  throw 'Not implemented'
}

export async function delete_gameContext(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_gameContext(): Promise<GameContext> {
  throw 'Not implemented'
}
